import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { injectIntl } from 'react-intl';
import { Tooltip } from '@material-ui/core';
import swal from 'sweetalert';
import $ from 'jquery';
import DataTable from 'datatables.net-bs4';
import 'datatables.net-bs4/css/dataTables.bootstrap4.css';
import AjaxHandler from '../../../commons/ajax/AjaxHandler.js';
import Security from '../../../commons/security/Security.js';
import Loading from '../../ui/Loading.js';
import Config from '../../../commons/config/Config.js';

$.DataTable = DataTable;

class DisponibilidadReglasGrid extends Component {
  constructor(props) {
    super(props);
    this.ajaxHandler = new AjaxHandler();
    this.state = {
      redirectTo: null,
      loading: false,
    };
  }

  componentDidMount() {
    if (!Security.hasPermission('DISPONIBILIDAD_REGLAS_LISTAR')) {
      window.location.href = '/error';
      return;
    }
    this.ajaxHandler.subscribe(this);
    this.initGrid();
  }

  componentWillUnmount() {
    this.ajaxHandler.unsubscribe(this);
  }

  initGrid() {
    // Silenciar el alert nativo de DataTables ante errores AJAX (ej: sesión expirada → 401).
    // El manejo del error queda en manos del AjaxHandler global (subscribe/unsubscribe).
    // Patrón tomado de MovStockTransferencia.js.
    $.fn.dataTable.ext.errMode = 'none';

    const component = this;
    const puedeModificar = Security.hasPermission('DISPONIBILIDAD_REGLAS_MODIFICAR');

    const columnaLocadora = {
      title: component.props.intl.formatMessage({
        id: 'disponibilidadReglas.columna.locadora',
        defaultMessage: 'Locadora',
      }),
      data: 'rentadora_nombre',
      className: 'all',
      filterType: 'input',
    };

    const columnaDias = {
      title: component.props.intl.formatMessage({
        id: 'disponibilidadReglas.columna.dias_sin_bip',
        defaultMessage: 'Días sin BIP',
      }),
      data: 'valor_int',
      className: 'all',
      filterType: 'input',
    };

    const columnaAcciones = {
      title: '',
      name: 'actions',
      orderable: false,
      className: 'all text-center',
      width: '120px',
      filterType: 'none',
      render: function(data, type, full) {
        const editarText = component.props.intl.formatMessage({
          id: 'disponibilidadReglas.accion.editar',
          defaultMessage: 'Editar',
        });
        const eliminarText = component.props.intl.formatMessage({
          id: 'disponibilidadReglas.accion.eliminar',
          defaultMessage: 'Eliminar',
        });
        return (
          '<button class="action edit btn btn-sm btn-icon btn-dt-grid text-success mr-1" title="' + editarText + '">' +
            '<i class="fa fa-pencil fa-xs"></i>' +
          '</button>' +
          '<button class="action delete btn btn-sm btn-icon btn-dt-grid text-danger" title="' + eliminarText + '">' +
            '<i class="fa fa-trash fa-xs"></i>' +
          '</button>'
        );
      },
    };

    const columns = puedeModificar
      ? [columnaLocadora, columnaDias, columnaAcciones]
      : [columnaLocadora, columnaDias];

    this.table = $(this.refs.grid).DataTable({
      dom: 'rt<"row mt-2"<"col-4" l><"col-4 text-center" i><"col-4" p>>',
      processing: true,
      serverSide: false,
      order: [[0, 'asc']],
      ajax: {
        type: 'GET',
        url: Config.get('apiUrlBase') + '/disponibilidad/reglas',
        headers: {
          'Authorization-Token': localStorage.getItem('token'),
        },
        dataSrc: function(response) {
          return response;
        },
        cache: false,
      },
      columns: columns,
      language: {
        emptyTable: component.props.intl.formatMessage({
          id: 'disponibilidadReglas.sin_reglas',
          defaultMessage: 'No hay reglas para locadoras configuradas',
        }),
        zeroRecords: component.props.intl.formatMessage({
          id: 'disponibilidadReglas.sin_reglas',
          defaultMessage: 'No hay reglas para locadoras configuradas',
        }),
      },
      initComplete: function(settings) {
        const api = this.api();
        api.columns().every(function() {
          const column = this;
          const colDef = settings.aoColumns[column.index()];

          if (colDef.filterType === 'input') {
            $('<input type="text" class="btn-dt-filter" placeholder="Buscar..." />')
              .appendTo($(column.footer()).empty())
              .on('keyup change', function() {
                if (column.search() !== this.value) {
                  column.search(this.value).draw();
                }
              });
          }
        });
        $('tfoot tr').appendTo('thead');
      },
    });

    // Event delegation para editar
    $(this.refs.grid).on('click', '.action.edit', function() {
      const row = component.table.row($(this).parents('tr')).data();
      if (row) {
        component.setState({
          redirectTo: {
            pathname: '/disponibilidad/reglas/' + row.id + '/edit',
            state: { regla: row },
          },
        });
      }
    });

    // Event delegation para eliminar
    $(this.refs.grid).on('click', '.action.delete', function() {
      const row = component.table.row($(this).parents('tr')).data();
      if (row) {
        component.handleEliminar(row);
      }
    });
  }

  handleNuevaRegla() {
    const reglasExistentes = this.table ? this.table.rows().data().toArray() : [];
    this.setState({
      redirectTo: {
        pathname: '/disponibilidad/reglas/add',
        state: { reglasExistentes: reglasExistentes },
      },
    });
  }

  handleEliminar(regla) {
    const component = this;
    swal({
      title: this.props.intl.formatMessage({
        id: 'disponibilidadReglas.confirmar_eliminacion.titulo',
        defaultMessage: '¿Confirma la eliminación?',
      }),
      text: this.props.intl.formatMessage(
        {
          id: 'disponibilidadReglas.confirmar_eliminacion.texto',
          defaultMessage:
            'Se eliminará la regla para la locadora "{locadora}". La locadora quedará fuera del opt-in del cron de desvinculación.',
        },
        { locadora: regla.rentadora_nombre }
      ),
      icon: 'warning',
      buttons: {
        confirm: {
          text: this.props.intl.formatMessage({
            id: 'disponibilidadReglas.confirmar_eliminacion.si',
            defaultMessage: 'Eliminar',
          }),
          value: true,
          visible: true,
          className: 'btn btn-primary',
          closeModal: false,
        },
        cancel: {
          text: this.props.intl.formatMessage({
            id: 'disponibilidadReglas.confirmar_eliminacion.no',
            defaultMessage: 'Cancelar',
          }),
          value: null,
          visible: true,
          className: 'btn btn-danger',
          closeModal: true,
        },
      },
    }).then(function(isConfirm) {
      if (isConfirm) {
        component.ajaxHandler
          .fetch('/disponibilidad/reglas/' + regla.id, {
            method: 'DELETE',
          })
          .then(function(response) {
            if (response.status === 200 || response.status === 204) {
              swal(
                component.props.intl.formatMessage({
                  id: 'disponibilidadReglas.eliminado.exito',
                  defaultMessage: 'Eliminado!',
                }),
                '',
                'success'
              );
              // Recarga sin perder filtro/orden actual
              component.table.ajax.reload(null, false);
            } else {
              component.ajaxHandler.handleResponseErrorsIsValid(response);
            }
          })
          .catch(function(error) {
            component.ajaxHandler.handleError(error);
          });
      }
    });
  }

  render() {
    const { redirectTo, loading } = this.state;
    const puedeModificar = Security.hasPermission('DISPONIBILIDAD_REGLAS_MODIFICAR');

    if (redirectTo) {
      return <Redirect push to={redirectTo} />;
    }

    // Número de columnas: 2 base + 1 si puede modificar
    const cantColumnas = puedeModificar ? 3 : 2;
    const thsFooter = [];
    for (let i = 0; i < cantColumnas; i++) {
      thsFooter.push(<th key={i}></th>);
    }

    return (
      <React.Fragment>
        {loading && <Loading />}
        <div className="row mt-2">
          <div className="col-12">
            <div className="card">
              <div className="card-content collapse show">
                <div className="card-body card-dashboard">
                  {puedeModificar && (
                    <div className="mb-1">
                      <Tooltip
                        title={this.props.intl.formatMessage({
                          id: 'disponibilidadReglas.agregar_regla',
                          defaultMessage: 'Agregar regla',
                        })}
                        arrow
                        placement="right"
                      >
                        <div
                          className="btn btn-primary box-shadow-2 btn-round btn-lg btn-dt-main round-icon"
                          style={{ height: 55 }}
                          onClick={this.handleNuevaRegla.bind(this)}
                        >
                          <i className="ft-plus"></i>
                        </div>
                      </Tooltip>
                    </div>
                  )}
                  <div className="table-responsive">
                    <table
                      id="dataTable"
                      className="table nowrap table-hover"
                      ref="grid"
                      width="100%"
                    >
                      <tfoot>
                        <tr style={{ backgroundColor: '#fff' }}>
                          {thsFooter}
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default injectIntl(DisponibilidadReglasGrid);
